














































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import RetensiStore from "@/store/modules/RetensiAlihMediaStore";
import {
  RetensiSession,
  RetensiChecklistItem,
  Penilaian,
  PenandaWajib,
} from "@/types/RetensiAlihMedia";

interface LocalRow {
  penilaian: Penilaian;
  bukti_text: string;
  catatan_auditor: string;
  rekomendasi_tindak_lanjut: string;
}

@Component({ name: "RetensiStepChecklist" })
export default class StepChecklist extends Vue {
  @Prop({ type: Object, default: null }) session!: RetensiSession | null;

  store = RetensiStore;
  activeTab = 0;
  saving = false;
  dirtyKodes = new Set<string>();
  local: Record<string, LocalRow> = {};

  get itemsByGroup(): Record<string, RetensiChecklistItem[]> {
    return this.store.checklistByKelompok;
  }

  get groupKeys(): string[] {
    return Object.keys(this.itemsByGroup).sort();
  }

  get totalItems(): number {
    return this.session?.checklist_items?.length ?? 0;
  }

  get filled(): number {
    return (this.session?.checklist_items ?? []).filter((i) => i.penilaian)
      .length;
  }

  get progressPercent(): number {
    if (this.totalItems === 0) return 0;
    return Math.round((this.filled / this.totalItems) * 100);
  }

  @Watch("session", { immediate: true, deep: true })
  onSessionChange(s: RetensiSession | null) {
    if (!s?.checklist_items) return;
    this.local = {};
    for (const it of s.checklist_items) {
      this.local[it.kode_item] = {
        penilaian: it.penilaian,
        bukti_text: it.bukti_text ?? "",
        catatan_auditor: it.catatan_auditor ?? "",
        rekomendasi_tindak_lanjut: it.rekomendasi_tindak_lanjut ?? "",
      };
    }
    this.dirtyKodes.clear();
  }

  isWajib(it: RetensiChecklistItem): boolean {
    const mandatory: PenandaWajib[] = [
      "PMK24",
      "MRMIK",
      "KMK1423",
      "UUPDP",
      "UUITE",
    ];
    return (it.penanda_wajib ?? []).some((p) => mandatory.includes(p));
  }

  markDirty(kode: string) {
    this.dirtyKodes.add(kode);
    this.dirtyKodes = new Set(this.dirtyKodes); // trigger reactivity
  }

  rekapForGroup(kelompok: string) {
    return this.session?.rekap_per_section?.[kelompok];
  }

  rekapColor(persen: number | null | undefined): string {
    if (persen === null || persen === undefined) return "grey";
    if (persen >= 90) return "green";
    if (persen >= 75) return "blue";
    if (persen >= 60) return "orange";
    return "red";
  }

  async saveBulk() {
    if (!this.session?.id || this.dirtyKodes.size === 0) return;
    this.saving = true;
    try {
      const items = Array.from(this.dirtyKodes).map((kode) => ({
        kode_item: kode,
        ...this.local[kode],
      }));
      await this.store.bulkSaveChecklist({
        sessionId: this.session.id,
        items,
      });
      this.dirtyKodes.clear();
      this.dirtyKodes = new Set();
      this.$emit("refresh");
    } finally {
      this.saving = false;
    }
  }
}
